"use strict";

// Import Swiper from 'swiper' (if you are using the Swiper library in regular JS, include Swiper through a CDN or import it directly)

// Utility Functions
function findOneElement(context, selector) {
  return context.querySelector(selector);
}

function initSection(selector, callback) {
  document.querySelectorAll(selector).forEach(callback);
}

function makeEventNamespace() {
  return {
    addDelegatedEventListener(context, selector, event, handler) {
      context.addEventListener(event, (e) => {
        if (e.target.matches(selector)) {
          handler(e.target, e);
        }
      });
    },
  };
}

function displayTestimonialsSection() {
  // when page is loaded, display the testimonials section
  const testimonialsSection = document.querySelector(
    ".unit203_testimonials-swiperContainer"
  );
  if (testimonialsSection) {
    testimonialsSection.style.opacity = 1;
  }
}

// Initialize the section with the `.js-pdp-testimonials-section` class
initSection(".js-pdp-testimonials-section", (section) => {
  // Find the swiper element
  const swiperElement = findOneElement(
    section,
    ".unit-203-swiper-container-testimonials"
  );
  const namespace = makeEventNamespace();

  // If the swiper element is not found, return unload with null
  if (swiperElement === null) return { unload: null };

  // Initialize the Swiper instance
  const swiperTestimonials = new Swiper(
    ".unit-203-swiper-container-testimonials",
    {
      // Use Swiper.Autoplay from the global Swiper object
      autoplay: {
        delay: 5000,
      },
      init: false,
      direction: "horizontal",
      slidesPerView: 1.18,
      centeredSlides: true,
      centeredSlidesBounds: true,
      loopAddBlankSlides: false,
      initialSlide: 2,
      spaceBetween: 15,
      speed: 500,
      autoplay: false,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: { slidesPerView: 1.3, spaceBetween: 24 },
        1024: { slidesPerView: 1.4, spaceBetween: 24 },
        1270: { slidesPerView: 2.25, spaceBetween: 32 },
      },
    }
  );

  // Initialize the swiper instance
  swiperTestimonials.init();

  // Return the unload function
  return {
    unload: () => {
      swiperTestimonials.destroy();
    },
  };
});

document.addEventListener("DOMContentLoaded", displayTestimonialsSection);